import React, { Dispatch, SetStateAction } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { pageLeftThunk } from '@redux/analytics/analyticsThunks';
import { PageType } from '@redux/analytics/analyticsTypes';
import { acceptInviteThunkV2, loginThunk, requestSmsVerificationThunk } from '@redux/oauth/oauthThunks';
import { AcceptAccountInviteRequest, LoginPayload } from '@redux/oauth/oauthTypes';
import { DevicePaneV2 } from '../../components/DualPane/Panes/DevicePaneV2/DevicePaneV2';
import { PhoneVerificationPaneV2 } from '../../components/DualPane/Panes/PhoneVerificationPaneV2/PhoneVerificationPaneV2';
import { DualPaneV2 } from '../../components/DualPaneV2/DualPaneV2';

interface Props {
  acceptInvite: Function;
  login: Function;
  pageLeft: Function;
  requestSmsVerification: Function;
}

const PhoneVerification: React.FC<Props> = ({ acceptInvite, login, pageLeft, requestSmsVerification }) => {
  return (
    <DualPaneV2
      pageLeft={pageLeft}
      pageType={PageType.INVITE_BY_TOKEN}
      leftPane={(loadingState: [boolean, Dispatch<SetStateAction<boolean>>], handleExternalRouting: (url?: Nullable<string>) => void, handleError: (err: any) => void) => (
        <PhoneVerificationPaneV2
          acceptInvite={acceptInvite}
          requestSmsVerification={requestSmsVerification}
          loadingState={loadingState}
          handleError={handleError}
          handleExternalRouting={handleExternalRouting}
        />
      )}
      rightPane={<DevicePaneV2 />}
    />
  );
};

const connectRedux = connect(
  () => {
    return {};
  },
  (dispatch: Function) => ({
    acceptInvite: async (acceptAccountInviteRequest: AcceptAccountInviteRequest, token: any) => {
      return dispatch(acceptInviteThunkV2(token, acceptAccountInviteRequest));
    },
    login: async (loginPayload: LoginPayload) => {
      return dispatch(loginThunk(loginPayload));
    },
    requestSmsVerification: async (token: string, phoneNumber: string) => {
      return dispatch(requestSmsVerificationThunk(token, phoneNumber));
    },
    pageLeft: async (pageType: PageType) => {
      return dispatch(pageLeftThunk(pageType));
    }
  })
);

export default compose(connectRedux)(PhoneVerification);
